module.exports = __webpack_public_path__ + "img/sup_deposit_crypto6.6aa5680c.jpg";